import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Grid } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfigsystem from "configs/NavigationConfig";
import { useSelector, useDispatch } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from "utils";
import { onMobileNavToggle } from "store/slices/themeSlice";
import styles from './menucontent.module.scss'
import ApiConfig from "configs/ApiConfig";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";

const { useBreakpoint } = Grid;

const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const MenuItem = ({ title, icon, path }) => {
  const dispatch = useDispatch();

  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");

  const closeMobileNav = () => {
    if (isMobile) {
      dispatch(onMobileNavToggle(false));
    }
  };

  return (
    <>
      {icon && <Icon type={icon} />}
      <span>{setLocale(title)}</span>
      {path && <Link onClick={closeMobileNav} to={path} />}
    </>
  );
};

const getSideNavMenuItem = (navItem) =>
  navItem.map((nav) => {
    return {
      key: nav.key,
      label: (
        <MenuItem
          title={nav.title}
          {...(nav.isGroupTitle ? {} : { path: nav.path, icon: nav.icon })}
        />
      ),
      ...(nav.isGroupTitle ? { type: "group" } : {}),
      ...(nav.submenu.length > 0
        ? { children: getSideNavMenuItem(nav.submenu) }
        : {}),
    };
  });

const getTopNavMenuItem = (navItem) =>
  navItem.map((nav) => {
    return {
      key: nav.key,
      label: (
        <MenuItem
          title={nav.title}
          icon={nav.icon}
          {...(nav.isGroupTitle ? {} : { path: nav.path })}
        />
      ),
      ...(nav.submenu.length > 0
        ? { children: getTopNavMenuItem(nav.submenu) }
        : {}),
    };
  });

const SideNavContent = (props) => {
  const { routeInfo, hideGroupTitle } = props;

  const sideNavTheme = useSelector((state) => state.theme.sideNavTheme);
  const menuItems = useMemo(() => getSideNavMenuItem(navigationConfigsystem), []);

  return (
    <Menu
      mode="inline"
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      style={{ height: "100%", borderInlineEnd: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
      items={menuItems}
    />
  );
};

const TopNavContent = () => {
  // eslint-disable-next-line no-unused-vars
  const topNavColor = useSelector((state) => state.theme.topNavColor);
  
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");
  
  const [hiddenroutes,sethiddenroutes]=useState([])
  const [loading,setloading]=useState(false)
  const [ruleslink,setRules]=useState("")
  
  const getAccountsettings = async () => {
    try {
      setloading(true)
      const response = await axios.get(`${env?.API_ENDPOINT_URL}/${ApiConfig.website.getaccountsettings}`);
    sethiddenroutes([ ...response?.data?.[0]?.hiddenmenu ]);setloading(false)
    setRules(response?.data?.[0]?.rule);
  } catch(err){console.log(err,'err123')
    setloading(false)}
  };
  useEffect(() => {
    getAccountsettings();
  }, []);

  const menuItems = useMemo(() => getTopNavMenuItem(navigationConfigsystem.filter((item)=>((item.key!=='login' || isMobile) && !(hiddenroutes?.includes(item.key))) )), [isMobile,hiddenroutes]);
  return (
    <>{loading?"":<Menu
      mode="horizontal"
      style={{
		    color: 'white',
        marginTop: isMobile?"0px":"70px",
        marginLeft: isMobile?"-12px":undefined,
        fontSize: isMobile?"12px":"18px",
        lineHeight: isMobile?"20px":"26px",
        position: "relative",
        display: "flex",
		    width:isMobile?"100vw":"100%",
        padding: isMobile?"45px 0px 5px 0px":"25px",
        backgroundColor: "#000"
      }}
      className={isMobile?styles.menucontent:undefined}
      items={menuItems}
      onClick={(e)=>{
        if(e.key==='login') window.location.href = process.env.REACT_APP_DEV_API_REDIRECT_URL
        if(e.key==='regulations') window.open(
          ruleslink,
          '_blank' // <- This is what makes it open in a new window.
        );//window.location.href = "https://leaguepro.s3.ca-central-1.amazonaws.com/documents/tcbl_rulebook.pdf"
        if(e.key==='faq' || e.key==='regulations') window.location.href =  (window.location.href.split('auth')[0]+'auth/'+e.key)
      }
      }
    />}</>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

export default MenuContent;
